import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { RoleEditSchema } from "../../../ValidationSchema";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


const SolutionEdit = () => {
  const location = useLocation();
  const Navigate = useNavigate();
  const [initialValues, setInitialValues] = useState({
    title: "",
    description: "",
    image_path: null,
    date_time: "",
  });

  const GetUserData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/blog-categories/edit-get?id=${location?.state?.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setInitialValues({
            name: res?.data?.data?.name,
          });
        }
      })
      .catch((err) => {

        const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
        const STATUS = [401, 403];
        if (
          STATUS.includes(err.response.status) ||
          MSG.includes(err.response.data.msg)
        ) {
          localStorage.clear();
          Navigate("/admin/login");
        } else {
          toast.error(err?.response?.data?.msg);
        }
      });
  };

  const EditSolution = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: RoleEditSchema,

    onSubmit: (values, action) => {
      let data = {
        id: location?.state?.id,
        name: values.name,
      };
      axios
        .post(`${process.env.REACT_APP_URL}/admin/product/store`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        })
        .then((res) => {
          if (res.status === 200) {
            toast.success(`Role Updated Successfully`);
            Navigate("/admin/role", { state: res.data.msg });
          }
        })
        .catch((err) => {
          toast.error(err.response.data.msg);
        });
    },
  });

  //   const UserRole = () => {
  //     axios
  //       .get(`${process.env.REACT_APP_URL}/common/roles`)
  //       .then((res) => {
  //         setUserRole(res.data.roles);
  //       })
  //       .catch((err) => {
  //         if (err.response.data.message === "Unauthorized!") {
  //           Navigate("/admin/login");
  //         }
  //       });
  //   };

  useEffect(() => {
    GetUserData();
  }, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Edit Solution</h1>
          <p className="al-sub">Update this solution.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={EditSolution.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18h6" /><path d="M10 22h4" /><path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.3h6c0-1 .4-1.8 1-2.3A7 7 0 0 0 12 2z" /></svg></div>
            <h3 className="al-cardhead__title">Solution Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Title</label>
              <input className="al-input" type="text" placeholder="Enter Title"
                value={EditSolution.values.title} onChange={EditSolution.handleChange} onBlur={EditSolution.handleBlur} name="title" />
              {EditSolution.errors.title && EditSolution.touched.title ? (
                <div className="al-err">{EditSolution.errors.title}</div>
              ) : null}
            </div>

            <div className="al-form__full">
              <label className="al-label">Description</label>
              <CKEditor
                editor={ClassicEditor}
                data={EditSolution.values.description}
                className="custom-ckeditor"
                onChange={(event, editor) => {
                  const data = editor.getData();
                  EditSolution.setFieldValue("description", data);
                }}
                onBlur={() => EditSolution.setFieldTouched("description", true)}
              />
              {EditSolution.errors.description && EditSolution.touched.description && (
                <div className="al-err">{EditSolution.errors.description}</div>
              )}
            </div>

            <div>
              <label className="al-label">Image</label>
              <input className="al-input al-input--file" type="file" name="image_path" accept="image/*"
                onChange={(e) => EditSolution.setFieldValue("image_path", e.target.files && e.target.files[0])}
                onBlur={EditSolution.handleBlur} />
              {EditSolution.errors.image_path && EditSolution.touched.image_path ? (
                <div className="al-err">{EditSolution.errors.image_path}</div>
              ) : null}
            </div>

            <div>
              <label className="al-label">Date Time</label>
              <input className="al-input" type="date" placeholder="Enter Date Time"
                value={EditSolution.values.title} onChange={EditSolution.handleChange} onBlur={EditSolution.handleBlur} name="date_time" />
              {EditSolution.errors.date_time && EditSolution.touched.date_time ? (
                <div className="al-err">{EditSolution.errors.date_time}</div>
              ) : null}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              Save Changes
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default SolutionEdit;
